import * as t from 'io-ts';
import { JobStatus, RateLimitKeyError } from '@/entities/aiChecklist/constants';

const jobStatus = t.keyof({
  [JobStatus.Started]: null,
  [JobStatus.Finished]: null,
  [JobStatus.Failed]: null,
});

const responses = t.type({
  uuid: t.string,
  title: t.string,
  color: t.string,
  score: t.union([t.number, t.null]),
  negative: t.boolean,
});

const responseSets = t.type({
  uuid: t.string,
  responses: t.union([t.array(responses), t.null, t.undefined]),
});

const aiTemplateForm = t.type({
  uuid: t.string,
  type: t.string,
  items: t.unknown,
  params: t.union([t.type({
    format_version: t.union([t.number, t.undefined]),
    response_sets: t.union([t.array(responseSets), t.null]),
  }), t.undefined]),
});

export const aiPromptIdeaCodec = t.type({
  id: t.number,
  name: t.string,
  title: t.string,
});

export const aiPromptCodec = t.type({
  prompt: t.string,
});

export const aiChecklistCodec = t.type({
  checklist_title: t.string,
  checklist_description: t.union([t.string, t.null]),
  form: aiTemplateForm,
});

export const aiPromptIdeasResponseCodec = t.type({
  data: t.array(aiPromptIdeaCodec),
});

export const aiChecklistCreateResponseCodec = t.type({
  data: t.type({
    uuid: t.string,
  }),
});

export const aiChecklistJobStatusResponseCodec = t.type({
  data: t.type({
    status: jobStatus,
    content: t.union([t.null, aiChecklistCodec]),
    meta: t.union([t.null, t.type({
      error: t.literal(RateLimitKeyError),
    })]),
  }),
});
